import React from "react";
import { Card } from "react-bootstrap";
import ClientMedia from "./ClientMedia";
import CtaLink from "../baseui/buttons/CtaLink";

const CardClients = ({ clients }) => {
  return (
    <div className="card-clients p-0">
      <Card.Title className="d-flex mb-0">
        <h5 className="mb-0">Clients</h5>
        <div className="ms-auto">
          <CtaLink cta="cta cta-primary" ctaText="View All" to="/clients" />
        </div>
      </Card.Title>
      <div className="card-body">
        <ClientMedia clients={clients} />
      </div>
    </div>
  );
};

export default CardClients;
